import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { take } from "rxjs";
import { BusquedaService } from "../../services/busqueda/busqueda.service";

@Component({
  selector: "app-consulta-historico",
  standalone: true,
  imports: [
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    CommonModule,
    RouterLink,
  ],
  templateUrl: "./consulta-historico.component.html",
  styleUrl: "./consulta-historico.component.css",
})
export class ConsultaHistoricoComponent {
  idTema: string = "";
  idEntrada: string = "";
  historico: any[] = [];
  comentarios: string = "";
  camposEncontrados: string = "";

  constructor(
    private route: ActivatedRoute,
    private busquedaService: BusquedaService
  ) {}

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.idTema = params.get("idTema") ?? "";
    this.idEntrada = params.get("idEntrada") ?? "";
    this.busquedaService
      .obtenerHistorico(this.idTema, this.idEntrada)
      .pipe(take(1))
      .subscribe((data) => {
        console.log("obtenerHistorico", data);
        data.empresa = data.empresa??' ';
        this.comentarios = data.comentarios.trim();
        const excludeKeys = [
          "confidencial",
          "fechaHoraReg",
          "responsable",
          "tema",
          "comentarios",
          "lock",
        ];
        const campo = this.route.snapshot.queryParamMap.get("campo");
        const campos = decodeURIComponent(campo ?? "");
        this.camposEncontrados = campos;

        const array = Object.keys(data)
          .filter((key) => !excludeKeys.includes(key))
          .map((key) => ({
            value: data[key],
            key,
            active:
              this.getNameKey(key) && campos.includes(this.getNameKey(key).key)
                ? true
                : false,
            des: this.getNameKey(key) ? this.getNameKey(key).name : "",
            orden: this.getNameKey(key) ? this.getNameKey(key).orden : 0,
          }))
          .sort((a, b) => a.orden - b.orden);

        this.historico = array;
        console.log("array", array);
      });
  }

  getNameKey = (field: string) => {
    const fields: any = {
      fechaEnt: { name: "FECHA ENT", key: "fechaEnt", active: false, orden: 1 },
      fechaFin: { name: "FECHA FIN", key: "fechaFin", active: false, orden: 2 },
      asunto: { name: "ASUNTO", key: "asunto", active: false, orden: 3 },
      descripcion: {
        name: "DESCRIPCIÓN",
        key: "descripcion",
        active: false,
        orden: 4,
      },
      remitente: {
        name: "REMITENTE",
        key: "remitente",
        active: false,
        orden: 5,
      },
      tema_descripcion: { name: "TEMA", key: "tema", active: false, orden: 6 },
      tipo: { name: "TIPO", key: "tipo", active: false, orden: 7 },
      modo_entrada: {
        name: "MODO ENTRADA",
        key: "modoEntrada",
        active: false,
        orden: 8,
      },
      prioridad: {
        name: "PRIORIDAD",
        key: "prioridad",
        active: false,
        orden: 9,
      },
      empresa: { 
        name: "EMPRESA", 
        key: "empresa", 
        active: false, 
        orden: 10 
      },
      delegado: {
        name: "DELEGAGO",
        key: "delegadoA",
        active: false,
        orden: 11,
      },
      estatus: { name: "ESTATUS", key: "estatus", active: false, orden: 12 },
      registrado: {
        name: "REGISTRADO",
        key: "registrado",
        active: false,
        orden: 13,
      },
      comentarios: {
        name: "COMENTARIOS",
        key: "comentarios",
        active: false,
        orden: 14,
      },
    };

    if (fields[field]) {
      return { ...fields[field], active: true };
    }
  };
}
